import { z } from 'zod';
export const IMAGE_SIZE_LIMIT = 10 * 1024 * 1024;
export const ImageFileSchema = z
	.custom<File>(file => file instanceof File, { message: 'Invalid file type. Expected a File object.' })
	.refine(file => file.size <= IMAGE_SIZE_LIMIT, { message: 'File size must be less than 5MB.' });

export const ProductReviewFormSchema = z.object({
	comment: z.string(),
	rating:  z.number(),
	images:  z.array(z.union([ ImageFileSchema, z.string(), z.undefined() ])),
});

export type ProductReviewFormType = z.infer<typeof ProductReviewFormSchema>;